// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"article-preview-module--previewTitle--16pYm","previewSubTitle":"article-preview-module--previewSubTitle--JxeOp","preview":"article-preview-module--preview--F8ZWM"};